export default __webpack_public_path__ + "static/media/books.1e70a937.svg";